import React, { PureComponent } from 'react';
import ReactGA from 'react-ga';

/* Polyfills for IE */
import 'utils/polyfill';
/* ------ */

import { Router } from 'react-static';
import { hot } from 'react-hot-loader';

import withConnectors from './connectors';

import Page from './components/Page';
import DynamicRouter from '../modules/DynamicRouter';

ReactGA.initialize('UA-152086656-1');

class App extends PureComponent {
  render() {
    return (
      <Router>
        <Page>
          <DynamicRouter />
        </Page>
      </Router>
    );
  }
}

export default hot(module)(withConnectors(App));



// WEBPACK FOOTER //
// /opt/build/repo/src/app/App.js